var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details"},[(_vm.popInfoImg.show)?_c('ImageDetails',{ref:"title",attrs:{"popInfo":_vm.popInfoImg,"closeBtn":"close"}}):_vm._e(),(_vm.popInfoVideo.show)?_c('VideoDetails',{ref:"title",attrs:{"popInfo":_vm.popInfoVideo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }